module.exports = __webpack_public_path__ + "media/images/home/mini/screen_10-b3315e8a818ef523b19e61b4333d349e.png";